class ErrorListController {
  constructor(DEBUG) {
    "ngInject";
    this.DEBUG = DEBUG;
  }
}

export default ErrorListController;
